const config = {
  space: '8j7amm9ckxfl',
  environment: 'master',
  accessToken: 'Sy12YaeamAoibGT4dZZb1b9TUoXCF-kbI1RVkNEptfc'
};

export default config;